/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelSnubCraftsParams,
  ModelSnubCraft,
  ModelSnubCraftInput,
  ModelSnubCrafts,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Snub Craft
 */
export const createModelSnubCraft = (
    modelSnubCraftInput: MaybeRefOrGetter<ModelSnubCraftInput>,
 signal?: AbortSignal
) => {
      modelSnubCraftInput = toValue(modelSnubCraftInput);

      return axiosClient<ModelSnubCraft>(
      {url: `/model-snub-crafts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelSnubCraftInput, signal
    },
      );
    }




export const getCreateModelSnubCraftMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelSnubCraft>>, TError,CreateModelSnubCraftMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelSnubCraft>>, TError,CreateModelSnubCraftMutationVariables, TContext> => {

const mutationKey = ['createModelSnubCraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelSnubCraft>>, CreateModelSnubCraftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelSnubCraft(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelSnubCraftMutationResult = NonNullable<Awaited<ReturnType<typeof createModelSnubCraft>>>
    export type CreateModelSnubCraftMutationBody = ModelSnubCraftInput
    export type CreateModelSnubCraftMutationError = ErrorType<ValidationError | StandardError>
    export type CreateModelSnubCraftMutationVariables = {data: ModelSnubCraftInput}

    /**
 * @summary Create Model Snub Craft
 */
export const useCreateModelSnubCraft = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelSnubCraft>>, TError,CreateModelSnubCraftMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelSnubCraft>>,
        TError,
        CreateModelSnubCraftMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelSnubCraftMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Snub Crafts list
 */
export const listModelSnubCrafts = (
    params?: MaybeRefOrGetter<ListModelSnubCraftsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelSnubCrafts>(
      {url: `/model-snub-crafts`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelSnubCraftsQueryKey = (params?: MaybeRefOrGetter<ListModelSnubCraftsParams>,) => {
    return [
    'model-snub-crafts', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelSnubCraftsQueryOptions = <TData = Awaited<ReturnType<typeof listModelSnubCrafts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelSnubCraftsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelSnubCrafts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelSnubCraftsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelSnubCrafts>>> = ({ signal }) => listModelSnubCrafts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelSnubCrafts>>, TError, TData>
}

export type ListModelSnubCraftsQueryResult = NonNullable<Awaited<ReturnType<typeof listModelSnubCrafts>>>
export type ListModelSnubCraftsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Snub Crafts list
 */

export function useListModelSnubCrafts<TData = Awaited<ReturnType<typeof listModelSnubCrafts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelSnubCraftsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelSnubCrafts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelSnubCraftsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Snub Craft
 */
export const destroyModelSnubCraft = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-snub-crafts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelSnubCraftMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelSnubCraft>>, TError,DestroyModelSnubCraftMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelSnubCraft>>, TError,DestroyModelSnubCraftMutationVariables, TContext> => {

const mutationKey = ['destroyModelSnubCraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelSnubCraft>>, DestroyModelSnubCraftMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelSnubCraft(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelSnubCraftMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelSnubCraft>>>

    export type DestroyModelSnubCraftMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelSnubCraftMutationVariables = {id: string}

    /**
 * @summary Destroy Model Snub Craft
 */
export const useDestroyModelSnubCraft = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelSnubCraft>>, TError,DestroyModelSnubCraftMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelSnubCraft>>,
        TError,
        DestroyModelSnubCraftMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelSnubCraftMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Snub Craft
 */
export const modelSnubCraft = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelSnubCraft>(
      {url: `/model-snub-crafts/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelSnubCraftQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-snub-crafts',id
    ] as const;
    }


export const getModelSnubCraftQueryOptions = <TData = Awaited<ReturnType<typeof modelSnubCraft>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSnubCraft>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelSnubCraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelSnubCraft>>> = ({ signal }) => modelSnubCraft(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelSnubCraft>>, TError, TData>
}

export type ModelSnubCraftQueryResult = NonNullable<Awaited<ReturnType<typeof modelSnubCraft>>>
export type ModelSnubCraftQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Snub Craft
 */

export function useModelSnubCraft<TData = Awaited<ReturnType<typeof modelSnubCraft>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSnubCraft>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelSnubCraftQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Snub Craft
 */
export const updateModelSnubCraft = (
    id: MaybeRefOrGetter<string>,
    modelSnubCraftInput: MaybeRefOrGetter<ModelSnubCraftInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelSnubCraftInput = toValue(modelSnubCraftInput);

      return axiosClient<ModelSnubCraft>(
      {url: `/model-snub-crafts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelSnubCraftInput, signal
    },
      );
    }




export const getUpdateModelSnubCraftMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelSnubCraft>>, TError,UpdateModelSnubCraftMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelSnubCraft>>, TError,UpdateModelSnubCraftMutationVariables, TContext> => {

const mutationKey = ['updateModelSnubCraft'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelSnubCraft>>, UpdateModelSnubCraftMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelSnubCraft(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelSnubCraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelSnubCraft>>>
    export type UpdateModelSnubCraftMutationBody = ModelSnubCraftInput
    export type UpdateModelSnubCraftMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelSnubCraftMutationVariables = {id: string;data: ModelSnubCraftInput}

    /**
 * @summary Update Model Snub Craft
 */
export const useUpdateModelSnubCraft = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelSnubCraft>>, TError,UpdateModelSnubCraftMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelSnubCraft>>,
        TError,
        UpdateModelSnubCraftMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelSnubCraftMutationOptions(options), queryClient);
    }
